import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  TextField,
  Link,
  InputAdornment,
  Paper,
  Divider,
  IconButton,
  Grid,
} from "@mui/material";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import * as yup from "yup";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { SIGNIN_START, RESET_STATE } from "Actions/AuthAction";
import "../../Sass/Auth.scss";
import Button from "Components/Common/Button/Button";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import logo from "Assets/Logo/RepeatSmart.svg";
import Sun from "Assets/Image/sun.png";
import Sign from "Assets/Icons/PharmsmartIcon/signin.svg";
import { setLocalStorage } from "utils/generalUtils";
import useViewport from "Hooks/useViewport";
import shop from "../../Assets/Image/odlellipse_shop.png";
import left_man_stay_bottom from "../../Assets/Image/left_man_stay_bottom.png";
import AutoLogOutInfoBox from "./AutoLogOutInfoBox";

const useStyle = makeStyles((theme) => ({
  repeatsmartLink: {
    textAlign: "right",
    marginBottom: "25px !important",
    marginTop: "10px !important",
  },
  rsDividerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "8px !important",
    "&>div": {
      margin: "0 6px !important",
      height: "36px",
      width: "36px",
      borderRadius: "20px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: `${theme.palette.white.main}`,
      boxShadow: "0px 4px 4px rgba(90, 104, 114, 0.15)",
    },
  },
  rsDividerLine: {
    width: "100px !important",
    height: "1px !important",
    background: "#ffffff !important",
  },
  rsButton: {
    textAlign: "center",
    marginTop: "30px !important",
    "&>button": {
      border: "1px solid #7bbd4b",
      backgroundColor: " #7bbd4b",
      color: "#fff",
      fontSize: "14px",
      padding: " 8px 20px",
      fontWeight: " 600",
      height: "45px",
      borderRadius: " 4px",
      minWidth: " 120px",
      // textTransform: "uppercase",
    },
  },
  rsPassword: {
    left: "15px !important",
    "&>svg": {
      height: "23px",
      width: "23px",
    },
  },
  resBoxlogin: {
    flexDirection: "column",
    "&>div": {
      bottom: "100px",
      [theme.breakpoints.down("700")]: {
        bottom: "115px",
      },
      [theme.breakpoints.down("520")]: {
        bottom: "100px",
      },
      [theme.breakpoints.down("380")]: {
        bottom: "40px",
      },
      [theme.breakpoints.down("350")]: {
        "&>h2": {
          fontSize: "1.125rem !important",
        },
      },
    },
    "&:before": {
      backgroundImage: `url(${shop})`,
      // background: `red`,
      content: '""',
      position: "absolute",
      width: "100%",
      height: "18.5vh",
      backgroundRepeat: "no-repeat",
      right: "0px",
      backgroundSize: "contain",
      backgroundPosition: "right",
      marginRight: "30px",
      bottom: "13%",
      [theme.breakpoints.down("1060")]: {
        // top: "50%",
        height: "10vh",
      },
      [theme.breakpoints.down("850")]: {
        height: "9vh",
      },
      // [theme.breakpoints.down("760")]: {
      //   // right: "95%",
      // },
    },
    "&>:before": {
      backgroundImage: `url(${left_man_stay_bottom})`,
      // background: `red`,
      content: '""',
      position: "absolute",
      width: "100%",
      height: "59.5vh",
      backgroundRepeat: "no-repeat",
      right: "100%",
      backgroundSize: "contain",
      backgroundPosition: "right",
      marginRight: "30px",
      top: "142px",
      [theme.breakpoints.down("1060")]: {
        top: "75%",
        height: "40vh",
      },
      [theme.breakpoints.down("885")]: {
        marginRight: "0px",
        top: "95%",
        height: "30vh",
      },
      [theme.breakpoints.down("760")]: {
        right: "95%",
      },
      [theme.breakpoints.down("700")]: {
        top: "105%",
        height: "28vh",
        right: "80%",
      },
      [theme.breakpoints.down("575")]: {
        top: "105%",
        height: "28vh",
        right: "80%",
      },
      [theme.breakpoints.down("520")]: {
        top: "105%",
        height: "28vh",
        right: "70%",
      },
      [theme.breakpoints.down("460")]: {
        top: "110%",
        height: "28vh",
        right: "70%",
      },
      [theme.breakpoints.down("400")]: {
        top: "115%",
        height: "28vh",
        right: "60%",
      },
      [theme.breakpoints.down("380")]: {
        top: "105%",
        height: "25vh",
        right: "65%",
      },
      [theme.breakpoints.down("350")]: {
        top: "110%",
      },
    },
  },
  resLoginHeader: {
    display: "flex",
    justifyContent: "space-between",
  },
  resLogo: {
    padding: "20px 30px 0px 30px",
    [theme.breakpoints.down("545")]: {
      width: "70%",
      height: "100%",
    },
    "&>img": {
      width: "340px",
      [theme.breakpoints.down("545")]: {
        width: "100%",
        height: "100%",
      },
    },
  },
  resSunImg: {
    [theme.breakpoints.down("545")]: {
      width: "25%",
      height: "100%",
    },
    "&>img": {
      width: "140px",
      [theme.breakpoints.down("545")]: {
        width: "100%",
        height: "100%",
      },
    },
  },
  rsContainer: {
    minHeight: "100vh",
    overflowX: "hidden",
    overflowY: "hidden",
    transition: "none !important",
    "&>div": {
      background: "#f5f5f5",
      height: "100vh",
      position: "relative",
    },
    "&>div:before": {
      content: '""',
      background: "#7FC783 !important",
      height: "13vh !important",
      position: "absolute !important",
      bottom: "0px !important",
      left: "0px !important",
      right: "0px !important",
      width: "100%",
    },
  },
}));

const Login = (props) => {
  const { userSigning, loginDetail, dispatchResetState } = props;
  const classes = useStyle();
  const navigate = useNavigate();
  const [isLoginProceed, setIsLoginProceed] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPin, setShowPin] = React.useState(false);
  const [showLogoutInfo, setShowLogoutInfo] = React.useState(false);
  const isInfoDailogOpen = JSON.parse(localStorage.getItem("LogoutFromFunc"));
  let { width } = useViewport();
  /**  Handle Login */
  const handleLogin = async (data) => {
    setIsLoginProceed(true);
    localStorage.setItem("LogoutFromFunc", JSON.stringify(false));
    localStorage.setItem("setLogoutDialog", JSON.stringify(true));
    localStorage.setItem("logOutFromInterceptor", JSON.stringify(false));
    localStorage.setItem("LogOutFromButton", JSON.stringify(false));
    const { email, password, type, pin } = data;
    if (pin.trim() != "") {
      userSigning({
        type: "pin",
        pin,
      });
    } else {
      userSigning({
        type: "credentials",
        email,
        password,
      });
    }
  };
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowPin = () => setShowPin((show) => !show);
  /** Handle Focus Of form field */
  const handleFocusOfFormField = (fieldType) => {
    if (fieldType === "pin") {
      //Blank credentials
      setFieldValue("email", "");
      setFieldValue("password", "");
    } else {
      //Blank pin
      setFieldValue("pin", "");
    }
  };

  /**  Login Validation Schema */
  const loginSchema = yup.object().shape({
    email: yup.string().when(["pin"], {
      is: (pin) => {
        return !pin;
      },
      then: yup
        .string()
        .required("Email is required field.")
        .email("Email should be valid"),
    }),
    password: yup.string().when(["pin"], {
      is: (pin) => {
        return !pin;
      },
      then: yup
        .string()
        .required("Password is required field.")
        .min(8, "Password length should be atleast 8 characters."),
    }),
  });

  /* Formik */
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    touched,
    setFieldError,
    setFieldValue,
    handleBlur,
  } = useFormik({
    initialValues: {
      email: "",
      password: "",
      pin: "",
    },
    validationSchema: loginSchema,
    onSubmit: handleLogin,
    enableReinitialize: true,
  });
  useEffect(() => {
    setLocalStorage("Pharmacies", "all");
  }, []);
  /** Login Success UseEffect */
  useEffect(() => {
    if (isLoginProceed) {
      if (!loginDetail.success) {
        if (loginDetail.errors) {
          const errorPresent = Object.keys(loginDetail.errors).length > 0;
          if (errorPresent > 0) {
            Object.keys(loginDetail.errors).forEach(function (key) {
              setFieldError(key, loginDetail.errors[key][0]);
            });
          }
        }
      } else {
        
        // Success Login
        localStorage.setItem("LastTokenRefreshedAt", Date.now());

        if (loginDetail?.data.data.data?.role === "user") {
          navigate("/home");
        } else {
          navigate("/home");
        }
        dispatchResetState("loginDetail");
      }
      setIsLoginProceed(false);
    }
  }, [loginDetail.success, loginDetail.errors]);

  useEffect(() => {
    if (isInfoDailogOpen) {
      setShowLogoutInfo(true);
    }
  }, [isInfoDailogOpen]);

  return (
    <>
      {width > 1100 ? (
        <Paper className="rsRoot">
          <Box className="login_header">
            <div className="rsLogo">
              <img src={logo} alt="" width="340px" />
            </div>
            {showLogoutInfo && (
              <AutoLogOutInfoBox
                open={showLogoutInfo}
                setOpen={setShowLogoutInfo}
              />
            )}
            <div>
              <img className="Sun_img" src={Sun} alt="" width="340px" />
            </div>
          </Box>
          <Box className="rsBxlogin">
            <div elevation={0} className="rsBoxsubroot">
              <img src={Sign} alt="" width="50" />
              <Typography variant="h2" semiBold style={{ color: "#000" }}>
                Sign in with credentials
              </Typography>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit();
                }}
                className="rsForm"
                autoComplete="off"
              >
                <TextField
                  className="RsInput"
                  secondary
                  fullWidth
                  name="email"
                  type="text"
                  placeholder="Email Address"
                  autoComplete="nope"
                  autoFocus
                  value={values.email}
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  newEmail="true"
                  onFocus={(e) => {
                    handleFocusOfFormField("email");
                  }}
                  InputProps={{
                    startAdornment: (
                      <>
                        {/* <InputAdornment position="start">
                    <PrimaryIcon width="20px" icon={EmailIcon} />
                  </InputAdornment>
                  <Divider className="rsInputDivider" /> */}
                      </>
                    ),
                  }}
                  error={touched.email && errors.email}
                  helperText={touched.email && errors.email}
                  InputLabelProps={{ shrink: true }}
                />
                <TextField
                  className="RsInput"
                  secondary
                  fullWidth
                  name="password"
                  // type="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  autoComplete="nope"
                  value={values.password}
                  newPassword="true"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  onFocus={(e) => {
                    handleFocusOfFormField("password");
                  }}
                  InputProps={{
                    startAdornment: (
                      <>
                        {/* <InputAdornment position="start">
                    <PrimaryIcon width="20px" icon={LockIcon} />
                  </InputAdornment>
                  <Divider className="rsInputDivider" /> */}
                      </>
                    ),

                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          onClick={handleClickShowPassword}
                          className={classes.rsPassword}
                        >
                          {showPassword ? (
                            <VisibilityOutlinedIcon />
                          ) : (
                            <VisibilityOffOutlinedIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  error={touched.password && errors.password}
                  helperText={touched.password && errors.password}
                  InputLabelProps={{ shrink: true }}
                />
                <Box className={classes.repeatsmartLink}>
                  <Link
                    onClick={() => navigate("/forgot-password")}
                    underline={"hover"}
                    color="secondary"
                    variant="h5"
                  >
                    Forgotten password?
                  </Link>
                </Box>
                {/* <Box className={classes.rsDividerContainer}>
            <Divider className={classes.rsDividerLine} />
            <Box>
              <Typography variant="h5" regular>
                Or
              </Typography>
            </Box>
            <Divider className={classes.rsDividerLine} />
          </Box> */}
                {/* <TextField
            secondary
            fullWidth
            name="pin"
            type={showPin ? "text" : "password"}
            // type="password"
            placeholder="Enter pin"
            autoComplete="nope"
            value={values.pin}
            onBlur={handleBlur}
            onChange={(e) => {
              handleChange(e);
            }}
            onFocus={(e) => {
              handleFocusOfFormField("pin");
            }}
            InputProps={{
              startAdornment: (
                <>
                  <InputAdornment position="start">
                    <PrimaryIcon width="20px" icon={PinIcon} />
                  </InputAdornment>
                  <Divider className="rsInputDivider" />
                </>
              ),
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    onClick={handleClickShowPin}
                    className={classes.rsPassword}
                  >
                    {showPin ? (
                      <VisibilityOutlinedIcon />
                    ) : (
                      <VisibilityOffOutlinedIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={touched.pin && errors.pin}
            helperText={touched.pin && errors.pin}
            InputLabelProps={{ shrink: true }}
          /> */}
                <Box className={classes.rsButton}>
                  <Button
                    children="Sign In"
                    variant="contained"
                    color="primary"
                    disabled={loginDetail?.isLoading}
                    loading={loginDetail?.isLoading}
                    type="submit"
                  />
                </Box>
              </form>
            </div>
          </Box>
        </Paper>
      ) : (
        <Grid className={classes.rsContainer}>
          <Paper>
            <Box className={classes.resLoginHeader}>
              <div className={classes.resLogo}>
                <img src={logo} alt="" />
              </div>
              <div className={classes.resSunImg}>
                <img src={Sun} alt="" />
              </div>
            </Box>
            <Box className={clsx("resBxlogin", classes.resBoxlogin)}>
              {showLogoutInfo && (
                <AutoLogOutInfoBox
                  open={showLogoutInfo}
                  setOpen={setShowLogoutInfo}
                />
              )}
              <div elevation={0} className="rsBoxsubroot">
                <img src={Sign} alt="" width="50" />
                <Typography variant="h2" semiBold style={{ color: "#000" }}>
                  Sign in with credentials
                </Typography>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                  className="rsForm"
                  autoComplete="off"
                >
                  <TextField
                    className="RsInput"
                    secondary
                    fullWidth
                    name="email"
                    type="text"
                    placeholder="Email Address"
                    autoComplete="nope"
                    autoFocus
                    value={values.email}
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    newEmail="true"
                    onFocus={(e) => {
                      handleFocusOfFormField("email");
                    }}
                    InputProps={{
                      startAdornment: (
                        <>
                          {/* <InputAdornment position="start">
                  <PrimaryIcon width="20px" icon={EmailIcon} />
                </InputAdornment>
                <Divider className="rsInputDivider" /> */}
                        </>
                      ),
                    }}
                    error={touched.email && errors.email}
                    helperText={touched.email && errors.email}
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    className="RsInput"
                    secondary
                    fullWidth
                    name="password"
                    // type="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    autoComplete="nope"
                    value={values.password}
                    newPassword="true"
                    onBlur={handleBlur}
                    onChange={(e) => {
                      handleChange(e);
                    }}
                    onFocus={(e) => {
                      handleFocusOfFormField("password");
                    }}
                    InputProps={{
                      startAdornment: (
                        <>
                          {/* <InputAdornment position="start">
                  <PrimaryIcon width="20px" icon={LockIcon} />
                </InputAdornment>
                <Divider className="rsInputDivider" /> */}
                        </>
                      ),

                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            onClick={handleClickShowPassword}
                            className={classes.rsPassword}
                          >
                            {showPassword ? (
                              <VisibilityOutlinedIcon />
                            ) : (
                              <VisibilityOffOutlinedIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={touched.password && errors.password}
                    helperText={touched.password && errors.password}
                    InputLabelProps={{ shrink: true }}
                  />
                  <Box className={classes.repeatsmartLink}>
                    <Link
                      onClick={() => navigate("/forgot-password")}
                      underline={"hover"}
                      color="secondary"
                      variant="h5"
                    >
                      Forgotten password?
                    </Link>
                  </Box>
                  <Box className={classes.rsButton}>
                    <Button
                      children="Sign In"
                      variant="contained"
                      color="primary"
                      disabled={loginDetail?.isLoading}
                      loading={loginDetail?.isLoading}
                      type="submit"
                    />
                  </Box>
                </form>
              </div>
            </Box>
          </Paper>
        </Grid>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  loginDetail: state.auth.loginDetail,
});
const mapDispatchToProps = (dispatch) => ({
  userSigning: (signinData) => dispatch({ type: SIGNIN_START, signinData }),
  dispatchResetState: (key, payload) =>
    dispatch({ type: RESET_STATE, key, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
